import VTabQuickTime from './index.vue';

export default {
  install: (Vue) => Vue.component('VTabQuickTime', VTabQuickTime),
};
